import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject, toTimezoneAndFormat } from 'Mri.Web.Common';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { BiStore } from '../BI/BiStore';
import { ActiveDisplay } from '../Displays/ActiveDisplay';
import { IDashboardDateRange } from './Dashboard';

export interface ITopDisplayItemProps {
    readonly display: ActiveDisplay;
    readonly selectedDateRange: IDashboardDateRange;
    readonly dateRange: Date[];
}

@autoinject
@observer
export class DashboardDisplay extends React.Component<ITopDisplayItemProps> {
    public render() {
        const { display } = this.props;
        return (
            <LinkContainer
                to={`/displays/${display.serialNumber}`}
                id="display-list-step-display"
                className="rounded bg-gray-darker mb-1 col-12 cursor-pointer"
            >
                <div className="">
                    <div className={this.statusClassName + ' row py-2'}>
                        <div className="col-4">
                            <div className="flex-items-center h-100">{display.serialNumber}</div>
                        </div>

                        <div className="col-4 text-center">
                            <div className="flex-items-center h-100">
                                <small>
                                    {display.pollTime
                                        ? toTimezoneAndFormat(display.pollTime, 'M/d/yy h:mm a', 'UTC')
                                        : '-'}
                                </small>
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="flex-items-center h-100">
                                <small>
                                    <i className="text-white">{display.statusMessageBrief}</i>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </LinkContainer>
        );
    }

    @computed
    private get statusClassName() {
        switch (this.props.display.videoState) {
            default:
                return 'dashboard-display-background-green';
            case 'showingVideo':
                return 'dashboard-display-background-green';
            case 'warning':
                return 'dashboard-display-background-warning';
            case 'noVideo':
                return 'dashboard-display-background-danger';
        }
    }

    @inject
    private biStore!: BiStore;
}
